import { render, staticRenderFns } from "./RocketTable.vue?vue&type=template&id=3251c708&"
import script from "./RocketTable.vue?vue&type=script&lang=js&"
export * from "./RocketTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports